exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numero[data-v-870d9d6e]{font-size:14px;padding-top:3px;padding-bottom:3px;width:27px;border-radius:20px}.gris[data-v-870d9d6e]{color:#7a7a7a}.textcuenta[data-v-870d9d6e]{font-weight:700}.is-select[data-v-870d9d6e]{color:#00d1b2;font-size:23px}.is-select1[data-v-870d9d6e]{color:#00d1b2;font-size:14px}.is-error[data-v-870d9d6e]{color:#ff3860}.datospruducto table[data-v-870d9d6e],.datospruducto td[data-v-870d9d6e],.datospruducto th[data-v-870d9d6e]{font-size:14px;padding-left:3px!important;padding-right:3px!important;color:#8b8b8b!important}.datospruducto tfoot[data-v-870d9d6e]{border:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-870d9d6e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Viewregistrofrapvta.vue
// module id = 527
// module chunks = 0